import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { logger } from "@/lib/logger";

const SettingsCtx = createContext(null);

const DEFAULTS = {
  platform_name: "InfiniteSkills Learning Portal",
  platform_subtitle: "Career Transformation Through Digital Skills",
  logo_url: "/brand/logo.png",
  favicon_url: "/brand/logo.png",
  primary_color: "#0B1B3A",
  secondary_color: "#D4AF37",
  footer_text: "InfiniteSkills Learning Portal · Channel Partner – NVDigitalEdu · Founded by Prerna Maheshwari",
  support_email: "support@infiniteskills.in",
  support_whatsapp: "https://wa.me/919999999999",
  whatsapp_community: "https://wa.me/919999999999",
  telegram_link: "https://t.me/infiniteskills",
  facebook_group: "",
  instagram_link: "",
  youtube_channel: "",
  zoom_default_link: "",
  default_trainer_name: "Prerna Maheshwari",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch (err) {
      // Non-fatal: keep DEFAULTS visible so the UI never blocks on branding load.
      logger.debug("[settings] refresh failed, keeping defaults:", err?.message || err);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Auto-refresh every 30s so student dashboards pick up admin changes.
    const t = setInterval(refresh, 30000);
    // Refresh whenever the tab regains focus.
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [refresh]);

  const value = useMemo(() => ({ settings, refresh, setSettings }), [settings, refresh]);
  return <SettingsCtx.Provider value={value}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx) || { settings: DEFAULTS, refresh: () => {}, setSettings: () => {} };
